import React, { useEffect, useState } from "react";
import { RefreshCw } from "lucide-react";

const mainSrc = (html) => (html.match(/\/static\/js\/main\.[a-z0-9]+\.js/i) || [])[0] || "";
const current = () => mainSrc(Array.from(document.scripts).map((s) => s.getAttribute("src") || "").join(" "));

// Checks for a newer deployed build and offers a one-tap reload (stops stale pages after a deploy).
export function UpdateBanner() {
  const [stale, setStale] = useState(false);
  useEffect(() => {
    const mine = current();
    if (!mine) { return undefined; }
    let stop = false;
    const check = async () => {
      if (stop || document.visibilityState === "hidden") return;
      try {
        const html = await (await fetch(`/?v=${Date.now()}`, { cache: "no-store" })).text();
        const live = mainSrc(html);
        if (live && live !== mine) setStale(true);
      } catch { /* offline */ }
    };
    const t = setInterval(check, 5 * 60 * 1000);
    document.addEventListener("visibilitychange", check);
    check();
    return () => { stop = true; clearInterval(t); document.removeEventListener("visibilitychange", check); };
  }, []);
  if (!stale) return null;
  return (
    <div className="fixed bottom-4 left-1/2 z-[100] flex -translate-x-1/2 items-center gap-3 rounded-full bg-[#12294B] py-2 pl-4 pr-2 text-sm text-white shadow-xl" data-testid="update-banner">
      <span>A new version of Somcore Hub is available</span>
      <button type="button" onClick={() => window.location.reload()} className="inline-flex items-center gap-1.5 rounded-full bg-[#A87F31] px-3 py-1.5 text-xs font-semibold hover:bg-[#8f6b28]" data-testid="update-banner-reload">
        <RefreshCw className="h-3.5 w-3.5" />Reload
      </button>
    </div>
  );
}
